import returnLevelObject from "../../scripts/calculateLevel"
import { toast } from "react-toastify"

const addAchievFunction = (conditionType) => {
    return async (dispatch, getState, { getFirestore }) => {
        const db = getFirestore()
        const getUid = getState().firebase.auth.uid
        const getComments = getState().firebase.profile.comments
        const getAdvices = getState().firebase.profile.advices
        const getCurrentAchievs = getState().firebase.profile.achievements
        const getInventory = getState().firebase.profile.inventory

        const completedTravels = getState().firebase.profile.travels.completedTravels
        const getCurrentChapter = getState().game.chapter

        const getWorldnewsGameTime = getState().studyGame.gameTime
        const getWorldnewsGameNumber = getState().firebase.profile.studyGame

        const requestAchievsArray = await db.collection('achievements').doc('achievements').get()
        const getAchievsArray = requestAchievsArray.data()

        // narrative specific chapter condition
        const specificChapterCondition = (countryName, capNumber) => {
            return completedTravels.find(item => item === `${countryName} ${capNumber}` || item === `${countryName} ${capNumber}` || item === `${countryName} ${capNumber}`)
        }

        // narrative completed 3 chapters of the same country
        const specificAllChaptersCondition = (countryName) => {
            const filterTravels = completedTravels.filter(item => item.includes(countryName))
            return filterTravels.length === 3 ? true : false
        }

        const compareLengthToNumber = (length, number) => {
            return length >= number ? true : false
        }

        const checkAchievConditions = (item) => {
            if (!getCurrentAchievs.find(achiev => achiev.name === item.name)) {
                let checkCondition

                switch (item.type) {
                    // check achievements about the narratives
                    case 'narrative':
                        if (completedTravels.length === 1 && getCurrentChapter === 'cap-1') {
                            checkCondition = item
                        } else if (completedTravels.length === item?.number) {
                            checkCondition = true
                        } else if (getCurrentChapter === 'cap-3') {
                            checkCondition = specificAllChaptersCondition(item?.country)
                        } else {
                            checkCondition = specificChapterCondition(item?.country, getCurrentChapter)
                        }
                        break
                    // check achievements about the worldsnews game
                    case 'worldnewsgame':
                        if (getWorldnewsGameNumber === item?.number) {
                            checkCondition = true
                        } else if (getWorldnewsGameTime !== 0) {
                            checkCondition = true
                        }
                        break
                    // check achievements about comments
                    case 'comments':
                        checkCondition = compareLengthToNumber(getComments.length, item?.number)
                        break
                    case 'advices':
                        checkCondition = compareLengthToNumber(getAdvices.length, item?.number)
                        break
                    case 'achievements':
                        checkCondition = compareLengthToNumber(getCurrentAchievs.length, item?.number)
                        break
                    case 'inventory-hats':
                        checkCondition = compareLengthToNumber(getInventory.hats.length, item?.number)
                        break
                    case 'inventory-bag':
                        checkCondition = compareLengthToNumber(getInventory.bag.length, item?.number)
                        break
                    default:
                        return null
                }

                if (checkCondition) {
                    dispatch({ type: 'ACHIEVEMENT_GOT_SUCCESS', payload: { rarity: item.rarity, name: item.name } })
                    return item
                } else {
                    dispatch({ type: 'NO_ACHIEVEMENT_GOT' })
                }
            } else {
                dispatch({ type: 'ALREADY_HAS_ACHIEVEMENT' })
            }
        }

        let foundAchievs = []

        // loop to check conditions and give users possible hats
        let filterAchievementsArray

        if (typeof conditionType === 'string') {
            filterAchievementsArray = getAchievsArray.achievs.filter(item => item.type === conditionType)
        } else {
            filterAchievementsArray = getAchievsArray.achievs.filter((item) => {
                for (let type of conditionType) {
                    if (type === item.type) {
                        return item
                    }
                }
            })
        }

        for (let item of filterAchievementsArray) {
            let achievement = checkAchievConditions(item)
            achievement && foundAchievs.push(achievement)
        }

        if (foundAchievs.length !== 0) {

            console.log(foundAchievs.length)

            let numberOfExpToAdd = 0;

            for (let i of foundAchievs) {
                numberOfExpToAdd += i.reward
            }

            const getCurrentLvl = getState().firebase.profile.level
            const getCurrentStatute = getState().firebase.profile.statute
            let getCurrentExp = getState().firebase.profile.experience

            const updateExperience = getCurrentExp += numberOfExpToAdd
            const getLevel = getCurrentLvl === 10 ? null : returnLevelObject(updateExperience, getCurrentLvl)
            const getLevelProps = getLevel ? Object.keys(getLevel).length : null

            if (getLevelProps && getLevelProps !== 2) {
                toast.success(getLevel.lvlMessage)
            }

            try {
                await db.collection('users').doc(getUid).update({
                    experience: updateExperience,
                    experiencePercentage: !getLevel && getCurrentLvl === 10 ? 100 : getLevel.lvlPercentage,
                    level: !getLevel ? getCurrentLvl : getLevel.level,
                    statute: getLevelProps?.statute ? getLevelProps.statute : getCurrentStatute,
                    achievements: getCurrentAchievs.concat(...foundAchievs)
                })
                dispatch({ type: 'ADD_ACHIEVEMENTS_SUCCESS' })
            } catch (err) {
                console.log(err)
                dispatch({ type: 'ADD_ACHIEVEMENTS_ERROR', error: err })
            }
        } else {
            dispatch({ type: 'NO_ACHIEVEMENT_GOT' })
        }
    }
}

export default addAchievFunction
